import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { HeaderStyle } from "../Common/styles/header";
import {
  MainTabPanel,
  StyledTabs,
  StyledTab,
  a11yProps,
} from "../Common/UI/TabPanel";
import { useSearchParams } from "react-router-dom";
import PlatformConsentsTracking from "./PlatformConsentsTracking";

const PlatformTrackerTabs = () => {
  const [type, setType] = useState<string>("consent");

  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState(searchParams.get("status") ?? "");
  const [page, setPage] = useState<number>(
    parseInt(searchParams.get("page") || "0") ?? 0
  );

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("type", type);
    params.set("page", page.toString());

    if (filter) {
      params.set("status", filter);
    }
    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, page, filter, type]);

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
    setPage(0);
    setFilter("");
  };
  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Tracker
        </Typography>
      </Box>
      {/* <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab label="Consent" value="consent" {...a11yProps(0)} />
          <StyledTab
            label="Sunshine Forms"
            value="sunshine"
            {...a11yProps(1)}
          />
        </StyledTabs>
      </Box> */}
      <Box
        sx={{
          borderTop: 1,
          borderColor: "#E5E7EB",
          borderBottom: "1px solid #E5E7EB",
          height: "calc(100vh - 132px)",
          overflow: "hidden",
          p: 2.5,
        }}
      >
        {/* <MainTabPanel value={type} index={type}> */}
        <PlatformConsentsTracking
          page={page}
          setPage={setPage}
          filter={filter}
          setFilter={setFilter}
          formType={type as "consent" | "sunshine"}
        />
        {/* </MainTabPanel> */}
      </Box>
    </>
  );
};

export default PlatformTrackerTabs;
